import { render, staticRenderFns } from "./CustomerMatchView.vue?vue&type=template&id=3e48fef6"
import script from "./CustomerMatchView.vue?vue&type=script&lang=ts"
export * from "./CustomerMatchView.vue?vue&type=script&lang=ts"
import style0 from "./CustomerMatchView.vue?vue&type=style&index=0&id=3e48fef6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports